'use client'

import React, { useState } from 'react'
import { Content, MobileHeader, NotificationType } from '@/components/ui'
import { Theme, useMediaQuery } from '@mui/material'
import SignInForm, { FormValues } from '@/components/registrant/SignInForm'
import { SendingLinkResultBlock } from '@/components/registrant/SendingLinkResultBlock'
import { MainContent } from '@/components/registrant/Registrant.styled'
import { useGtm, useNotification } from '@/hooks'
import { MessageType } from '@/interfaces/socket'
import { Utils } from '@/lib/utils'
import { RegistrantController } from '@/controllers'
import { GTM_EVENT } from '@/interfaces/gtm'
import { useRegistrantSocket } from '@/components/registrant/useRegistrantSocket'

const RegistrantSignIn: React.FC = () => {
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down('sm'))
  const [isAuthLinkSent, setAuthLinkSent] = useState<boolean>(false)
  const { openNotification } = useNotification()
  const { sendDataToGTM } = useGtm()
  const { initSocketConnection, sendMessage } = useRegistrantSocket(MessageType.SIGNIN)

  const sendSocketMessage = (phone: string) => {
    sendMessage({ phone })
  }

  const sendAuthLink = async ({ phone, ...values }: FormValues) => {
    const data = {
      ...values,
      phone: Utils.formatPhoneNumber(phone),
    }
    const {
      result: [error],
    } = await RegistrantController.signIn(data.phone)

    if (error) {
      openNotification(error, NotificationType.ERROR)
      return
    }

    setAuthLinkSent(true)
    initSocketConnection(() => sendSocketMessage(data.phone))
    sendSocketMessage(data.phone)
    sendDataToGTM({ event: GTM_EVENT.LOG_IN_AUTH_LINK })
    sendDataToGTM({ event: GTM_EVENT.LOG_IN_WAITING_PAGE })
  }

  return (
    <Content sx={{ height: '100%', pt: isMobile ? 0 : 6, px: isMobile ? 0 : 4 }}>
      {isMobile && <MobileHeader logoSize={{ width: 244, height: 53 }} bgSize={{ height: 170, top: -20 }} />}
      <MainContent>
        {!isAuthLinkSent ? (
          <SignInForm onSubmit={sendAuthLink} />
        ) : (
          <SendingLinkResultBlock onClose={() => setAuthLinkSent(false)} />
        )}
      </MainContent>
    </Content>
  )
}

export default RegistrantSignIn
